import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import { common } from '../../../style';
import { IButtonProps } from '../../../Interfaces/IButtonProps';
import { neutral } from '../../../style/colors';

const Button = (props: IButtonProps) => {
  const { toggled, onClick, children } = props;
  const [outline, setOutline] = useState('solid 1px transparent');
  let { theme } = props;
  if (!theme) {
    theme = {
      top: 0,
    };
  }
  const toggleAnimation = useSpring({
    boxShadow: toggled ? common.boxShadow : '0 4px 12px 0 rgba(16, 42, 67, 0.1)',
    backgroundColor: toggled ? '#ffffff' : neutral[100],
    position: 'absolute',
    top: theme.top,
    pointerEvents: 'auto',
    cursor: 'pointer',
    zIndex: 2,
    height: 54,
    width: 54,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
    outline: outline,
  });

  return (
    <animated.button
      style={toggleAnimation}
      onClick={() => (onClick ? onClick() : () => { })}
      onFocus={() => setOutline(`solid 1px ${neutral[400]}`)}
      onBlur={() => setOutline('solid 1px transparent')}
    >
      {children}
    </animated.button>
  );
};

export default Button;
